import React from "react";

const Preview = ({ images, label }) => {
  return (
    <div
      className={
        images.length > 0 ? "card rounded-semi" : "card rounded-semi d-none"
      }
      style={{ height: "450px" }}
    >
      <div className="card-header top-rounded-semi">{label}</div>
      <div className="card-body">
        <div className="col vertical-scroll" style={{ maxHeight: "360px" }}>
          {images.map((img, i) => {
            return (
              <img
                className="image-preview p-1"
                src={img}
                alt={"image-" + i}
                key={i}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Preview;
